module.exports = __webpack_public_path__ + "static/media/eng_d_2355.15616c1a.mp4";